export interface ILanguage {
    id: number;
    oldId: number;
    name: string;
    description: string;
    nameShort: string;
    abbreviation: string;
    lcid: number;
}

export function getAvailableLanguages(): Map<number, ILanguage> {
    let result = new Map<number, ILanguage>();
    result.set(12,
        {
            id: 12,
            oldId: 1,
            name: 'česky',
            nameShort: 'Čeština',
            description: 'CZE',
            abbreviation: 'cs',
            lcid: 1029
        });
    result.set(0, {
        id: 0,
        oldId: 2,
        name: 'english',
        nameShort: 'English',
        description: 'ENG',
        abbreviation: 'en',
        lcid: 1033
    });
    result.set(17, {
        id: 17,
        oldId: 3,
        name: 'slovensky',
        nameShort: 'Slovenčina',
        description: 'SVK',
        abbreviation: 'sk',
        lcid: 1051
    });
    result.set(21, {
        id: 21,
        oldId: 7,
        name: 'По Русски',
        nameShort: 'русский',
        description: 'RUS',
        abbreviation: 'ru',
        lcid: 1049
    });
    result.set(25, {
        id: 25,
        oldId: 8,
        name: 'latviešu',
        nameShort: 'Latvijas',
        description: 'LVA',
        abbreviation: 'lv',
        lcid: 1062
    });
    return result;
}